import { FormSearchWrapper } from "./styled"

const FormSearch = ({ placeholder, queryInput, setQueryInput, onChange }) => {
    const handleClearInput = () => {
        setQueryInput('')
    }
    return (
        <FormSearchWrapper>
            <form className="form-search b-color4-1">
                <input
                    placeholder={placeholder}
                    value={queryInput}
                    onChange={onChange}
                    className="text-color2"
                />
                <span className='btn_clear'>
                    {
                        queryInput !== '' &&
                        <i className="ti-close"
                            onClick={handleClearInput}
                        ></i>
                    }
                </span>
                <span className='btn_search bg-color18 bl-color4-1'>
                    <i className="ti-search"></i>
                </span>
            </form>
        </FormSearchWrapper>
    );
}

export default FormSearch;